import module from '../gift-deets.module';

module.factory('GiftDetailsService', [
  '$resource',
  'CurrentUserService',
  function ($resource, CurrentUserService) {
    var GiftDetailsResource = $resource('/api/gift-details/:giftId', { giftId: '@id' });
    var saveResource = $resource('/api/gift-details');

    return {
      markAsBought: function (gift) {
        var rs = $resource('/api/mark-gift-as-bought');
        return rs.save({
          giftId: gift.id,
        }).$promise;
      },

      save: function (gift) {
        gift.suggestedBy = CurrentUserService.currentUser.id;
        return saveResource.save(gift).$promise;
      },

      getDetails: function (giftId) {
        return GiftDetailsResource.get({ giftId }).$promise;
      },

      deleteGift: function (gift) {
        var rs = $resource('/api/mark-gift-as-deleted');
        return rs.save({
          giftId: gift.id,
        }).$promise;
      },

      unbuyGift: function (gift) {
        var rs = $resource('/api/unmark-gift-as-bought');
        return rs.save({
          giftId: gift.id,
        }).$promise;
      },
    };
  },
]);
